<template>
  <div>
    <CommonHeader
      :class="{ 'style-index': indexFlag, 'style-common': !indexFlag }"
      class="common"
    />
    <router-view />
    <CommonFooter />
  </div>
</template>

<script>
import CommonHeader from "@/components/CommonHeader";
import CommonFooter from "@/components/CommonFooter";

export default {
  components: { CommonHeader, CommonFooter },
  data() {
    return {
      indexFlag: false,
    };
  },

  watch: {
    $route(newRoute, oldRoute) {
      this.indexFlag =
        newRoute.path === "/" || newRoute.path.toLowerCase() === "/main";
    },
  },
  created() {
    this.indexFlag =
      this.$route.path === "/" || this.$route.path.toLowerCase() === "/main";
  },
};
</script>
<style lang="less" scoped>
.common {
  z-index: 8000;
  width: 100%;
}

.style-index {
  position: absolute;
}

.style-common {
  position: unset;
}
</style>
